import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { L as Link } from '../Link/Link-CQf6-EGl.js';
import { T as TextButton } from '../Button/TextButton/TextButton-Ca8KdYfe.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';
import { T as Text } from '../Text/Text-Ce2yOjWM.js';

const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-beoevh-0"
})(["padding-block-start:", ";padding-block-end:", ";display:flex;flex-direction:row;align-items:center;", ""], ({
  theme
}) => theme.controls.paddingBlock.base.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, isMobile(css(["padding-block-start:", ";padding-block-end:", ";"], ({
  theme
}) => theme.controls.paddingBlock.base.mobile, ({
  theme
}) => theme.controls.paddingBlock.base.mobile)));
const BreadcrumbArrow = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-beoevh-1"
})(["color:", ";margin-inline-start:", ";", ""], ({
  theme
}) => theme.icon.color.tertiary, ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["margin-inline-start:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const StyledText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40025937__sc-beoevh-2"
})(["color:", ";"], ({
  theme
}) => theme.text.color.secondary);
const BreadcrumbBody = ({
  href,
  label,
  onClick,
  children,
  elementRef,
  ...rest
}) => {
  if (children) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  if (href) {
    return /*#__PURE__*/React__default.createElement(Link, _extends({}, rest, {
      href: href,
      anchorRef: elementRef
    }), label);
  }
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
      onClick: onClick,
      buttonRef: elementRef
    }), label);
  }
  return /*#__PURE__*/React__default.createElement(StyledText, _extends({}, rest, {
    elementRef: elementRef
  }), label);
};
const Breadcrumb = ({
  isFinal = false,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(BreadcrumbBody, restProps), !isFinal && /*#__PURE__*/React__default.createElement(BreadcrumbArrow, {
  type: angleInlineEnd,
  size: "xsmall"
}));

export { Breadcrumb as B };
//# sourceMappingURL=Breadcrumb-D9L5Py-a.js.map
